import { ValidationErrors } from '@angular/forms';

export function validateEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function validateMultipleEmails(emails: string): boolean {
  if (!emails) return true;
  const emailList = emails.split(',').map(email => email.trim());
  return emailList.every(email => validateEmail(email));
}

export function parseEmails(emailString: string): string[] {
  return emailString
    .split(',')
    .map(email => email.trim())
    .filter(email => email.length > 0);
}

export function multipleEmailValidator(value: string | null): ValidationErrors | null {
  if (!value) return null;

  const emails = value.split(',').map((email: string) => email.trim());
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  for (const email of emails) {
    if (email && !emailRegex.test(email)) {
      return { invalidEmail: true };
    }
  }

  return null;
}
